import React from "react";
import { ErrorAlert } from "components/errorAlert/ErrorAlert";

export const Error404 = () => {
  return (
    <ErrorAlert
      title="Page Not Found."
      errorCode={404}
      buttonTitle="Return to Main Page"
      onClick={() => window.location.replace("/")}
    >
      <React.Fragment>
        <p>Please check if you have entered the correct URL.</p>
      </React.Fragment>
    </ErrorAlert>
  );
};
